"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadProfilesInZip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const partition_1 = __importDefault(require("lodash/partition"));
const file_saver_1 = require("file-saver");
const jszip_1 = __importDefault(require("jszip"));
const Api = __importStar(require("@src/api"));
const isApplicantAccountAnonymized_1 = require("@src/helpers/isApplicantAccountAnonymized");
const downloadProfilesInZip = async (applicants, intl, offerTitle) => {
    var _a, _b, _c, _d;
    const applicantsWithDocuments = applicants.filter(app => !(0, isApplicantAccountAnonymized_1.isApplicantAccountAnonymized)(app.account));
    const resumesByType = (0, partition_1.default)(applicantsWithDocuments, application => application.account_uuid);
    const applicantsWithProfileResume = resumesByType[0];
    const applicantsWithUploadedResume = resumesByType[1];
    try {
        const zip = new jszip_1.default();
        if (applicantsWithProfileResume.length > 0) {
            for (const applicantWithProfile of applicantsWithProfileResume) {
                const applicantProfile = await Api.Profile.getApplicantProfile(applicantWithProfile.account_uuid);
                const fileName = `${applicantProfile === null || applicantProfile === void 0 ? void 0 : applicantProfile.first_name}_${applicantProfile === null || applicantProfile === void 0 ? void 0 : applicantProfile.last_name}_${applicantWithProfile.account_uuid}.pdf`;
                const { pdf } = await Promise.resolve().then(() => __importStar(require('@react-pdf/renderer')));
                const { ApplicantProfilePDF } = await Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/resume/PDF/ApplicantProfilePDF')));
                const applicantProfilePDF = await pdf((0, jsx_runtime_1.jsx)(ApplicantProfilePDF, { applicantProfile: applicantProfile })).toBlob();
                zip.file(fileName, applicantProfilePDF);
            }
        }
        if (applicantsWithUploadedResume.length > 0) {
            for (const applicantWithResume of applicantsWithUploadedResume) {
                if (!((_a = applicantWithResume.resume) === null || _a === void 0 ? void 0 : _a.resume_url)) {
                    throw new Error('No resume attached');
                }
                const resumeRequest = new Request(applicantWithResume.resume.resume_url);
                const response = await fetch(resumeRequest);
                const blobFile = await response.blob();
                const fileName = `${(_b = applicantWithResume.account) === null || _b === void 0 ? void 0 : _b.first_name}_${(_c = applicantWithResume.account) === null || _c === void 0 ? void 0 : _c.last_name}_${(_d = applicantWithResume.resume) === null || _d === void 0 ? void 0 : _d.resume_name}.pdf`;
                zip.file(fileName, blobFile);
            }
        }
        const zipFile = await zip.generateAsync({ type: 'blob' });
        (0, file_saver_1.saveAs)(zipFile, `${offerTitle}.zip`);
    }
    catch (err) {
        antd_1.notification.error({
            message: intl.formatMessage({
                id: 'global.notification_variants.error',
            }),
            description: intl.formatMessage({
                id: 'global.notification_variants.something_went_wrong',
            }),
        });
        // eslint-disable-next-line no-console
        console.error(err);
    }
};
exports.downloadProfilesInZip = downloadProfilesInZip;
